// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Component Imports
// JS Imports
// Asset Imports

export default function NonProfitDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const { getString } = state

   return (
      <div className='row' style={{ order: order }}>
         <div className='col-bhr1'>
            <DiscountDescriptionBox
               discountDescription={
                  state.discount_list['nonProfit']['DiscountDescription']
               }
               discountName={state.discount_list['nonProfit']['DiscountName']}
               hoverTitle={getString(
                  'product.NonProfitDiscountRow.DiscountDescriptionBox.HoverText',
               )}
            />
         </div>
         <div className='col'>
            <input
               className='input-field'
               type='checkbox'
               checked={state.discountNonProfit}
               onChange={() => state.setDiscountNonProfit((prev) => !prev)}
            ></input>
         </div>
         <div className='col'>
            {state.discount_list['nonProfit']['DiscountAmount']}%
         </div>
      </div>
   )
}
